import { cn } from "@theprelude/core";

export const MimecastIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 21.4949V2.90585H18.2539C22.0579 2.90585 23.9864 4.83434 23.9864 8.63978V21.5206H19.1015V8.25317C19.2045 7.71343 18.7937 7.22525 18.2539 7.12215H17.9447H14.397V21.4433H9.56361V7.14793H4.8849V21.4949H0Z" />
  </svg>
);
